import type { NavigableObject } from "../ObjectNavigationBar/types";

/**
 * Pass as `onAfterNavigate` when the parent fully owns post-step zoom behavior
 * and the panel's built-in point-zoom should not run (e.g. when the navigated
 * objects do not carry a `position` field).
 */
export const skipPanelNavigationZoom: (object: NavigableObject) => void =
  () => {};
